import React, { ReactNode, CSSProperties } from "react"
import useDeviceType from "../../../../hooks/useDeviceType"
import * as styles from "./Float.module.css"
import classNames from "classnames"

type FloatProps = {
  children: ReactNode
  top?: number | string
  right?: number | string
  bottom?: number | string
  left?: number | string
  rotate?: number
  backgroundImage?: boolean
  removeResponsive?: boolean
  centerResponsive?: boolean
  littleResponsive?: boolean
  style?: CSSProperties
}

const Float = ({
  children,
  top,
  right,
  bottom,
  left,
  rotate,
  backgroundImage = false,
  removeResponsive = false,
  centerResponsive = false,
  littleResponsive = false,
  style = {},
}: FloatProps) => {
  //

  const DeviceType = useDeviceType()

  const positionStyle: CSSProperties = {
    position: "absolute",
    zIndex: backgroundImage ? -1 : 10,
    top: typeof top === "number" ? `${top}px` : top,
    bottom: typeof bottom === "number" ? `${bottom}px` : bottom,
    right: typeof right === "number" ? `${right}px` : right,
    left: typeof left === "number" ? `${left}px` : left,
    transform: rotate ? `rotate(${rotate}deg)` : undefined,
    ...style,
  }

  if (
    removeResponsive &&
    (DeviceType === "tablet" || DeviceType === "mobile")
  ) {
    return
  } else {
    return (
      <div
        style={positionStyle}
        className={classNames({
          [styles.centerResponsive]: centerResponsive,
          [styles.littellResponsive]: littleResponsive,
        })}
      >
        {children}
      </div>
    )
  }
}

export default Float
